/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { ContractType } from './';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './';
import type { FixedPriceProjectContractDetailsResource } from './';
import {
    FixedPriceProjectContractDetailsResourceFromJSON,
    FixedPriceProjectContractDetailsResourceFromJSONTyped,
    FixedPriceProjectContractDetailsResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { ProjectContractResource } from './';
import {
    ProjectContractResourceFromJSON,
    ProjectContractResourceFromJSONTyped,
    ProjectContractResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceProjectContractResource
 */
export interface FixedPriceProjectContractResource extends ProjectContractResource {
    /**
     * 
     * @type {FixedPriceProjectContractDetailsResource}
     * @memberof FixedPriceProjectContractResource
     */
    details: FixedPriceProjectContractDetailsResource;
}

/**
 * Check if a given object implements the FixedPriceProjectContractResource interface.
 */
export function instanceOfFixedPriceProjectContractResource(value: object): value is FixedPriceProjectContractResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function FixedPriceProjectContractResourceFromJSON(json: any): FixedPriceProjectContractResource {
    return FixedPriceProjectContractResourceFromJSONTyped(json, false);
}

export function FixedPriceProjectContractResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceProjectContractResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectContractResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': FixedPriceProjectContractDetailsResourceFromJSON(json['details']),
    };
}

export function FixedPriceProjectContractResourceToJSON(value?: FixedPriceProjectContractResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectContractResourceToJSON(value, true),
        'details': FixedPriceProjectContractDetailsResourceToJSON(value['details']),
    };
}

